import type { BuyerPaymentMethod } from './contract';
import type { FunnelDecision } from './funnel';
import type { CheckoutVoucher } from './api';

export interface HostedFunnelPending {
  originalSaleId: string;
  handoffId: string | null;
  nodeId: string;
  saleId: string | null;
  voucher: CheckoutVoucher | null;
  method: BuyerPaymentMethod;
  decisions: FunnelDecision[];
}

// Session IDs rotate after the primary purchase completes; checkout + tab stay stable.
const key = (checkoutId: string) => `vendepay:hosted-funnel-pending:checkout:${checkoutId}`;

export function saveHostedFunnelPending(checkoutId: string | undefined, pending: HostedFunnelPending): void {
  if (!checkoutId) return;
  try {
    window.sessionStorage.setItem(key(checkoutId), JSON.stringify(pending));
  } catch { /* The current page can still await Core when storage is unavailable. */ }
}

export function clearHostedFunnelPending(checkoutId: string | undefined): void {
  if (!checkoutId) return;
  try { window.sessionStorage.removeItem(key(checkoutId)); } catch { /* Storage unavailable. */ }
}

export function loadHostedFunnelPending(checkoutId: string | undefined): HostedFunnelPending | null {
  if (!checkoutId) return null;
  try {
    const value = JSON.parse(window.sessionStorage.getItem(key(checkoutId)) ?? 'null') as HostedFunnelPending | null;
    if (!value || typeof value.originalSaleId !== 'string' || typeof value.nodeId !== 'string'
      || (value.handoffId !== null && typeof value.handoffId !== 'string')
      || (value.saleId !== null && typeof value.saleId !== 'string')
      || !['card', 'pix', 'boleto'].includes(value.method) || !Array.isArray(value.decisions)
      || !value.decisions.every((decision) => decision && typeof decision.nodeId === 'string'
        && typeof decision.parentNodeId === 'string' && ['paid', 'reserved', 'rejected'].includes(decision.status))) return null;
    return value;
  } catch { return null; }
}
